export enum LLMClassifierPurpose {
    Quality,
    Insights,
    ExtractData,
}
